import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { combineLatest, Observable } from 'rxjs';
import { selectQuotingEditorActive } from '../../../store/quote-progress/quote-progress.state';
import {
    selectShipmentEditable,
    selectShipmentEditorChangedAt, selectShipmentEditorSavedAt,
    selectShipmentEditorUnsaved,
    selectShipmentEditorValid
} from '../../../store/shipment-editor/shipment-editor.state';
import { map } from 'rxjs/operators';
import { MatTooltip } from '@angular/material/tooltip';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-save-indicator',
    templateUrl: './save-indicator.component.html',
    styleUrls: ['./save-indicator.component.scss'],
    imports: [MatTooltip, AsyncPipe]
})
export class SaveIndicatorComponent implements OnInit {

    canDisplay$: Observable<boolean>;
    unsavedIndicator$: Observable<boolean>;
    savedAt$: Observable<Date>;

    constructor(private store: Store<AppState>) {
    }

    ngOnInit(): void {
        this.canDisplay$ = combineLatest([
            this.store.select(selectShipmentEditorValid),
            this.store.select(selectShipmentEditorChangedAt),
            this.store.select(selectShipmentEditable)
        ]).pipe(
            map(([ valid, changedAt, editable ]) => valid && !!changedAt && editable)
        );
        this.unsavedIndicator$ = this.store.select(selectShipmentEditorUnsaved);
        this.savedAt$ = this.store.select(selectShipmentEditorSavedAt).pipe(
            map((timestamp) => new Date(timestamp))
        );
    }

}
